class ScoreDetailsInfo {
    constructor({ subScoreDetails = [], score = 0 }) {
        this.subScoreDetails = subScoreDetails;
        this.score = score;
    }

    get subScoreDetails() { return this._subScoreDetails }
    set subScoreDetails(value) { this._subScoreDetails = value }

    get score() { return this._score }
    set score(value) { this._score = value }
}

export default ScoreDetailsInfo;